/**
 * Created by adaltojunior on 2/6/15.
 */

Greenmile.Marker = Greenmile.Marker || {};
Greenmile.Marker.EquipmentInOff = function (map, routeId) {

    var _data = [];

    this.setData = function (data) {
        _data = data;
        return this;
    };

    this.defaultPopup = function (marker) {

        var coordinate = marker.coordinates;
        var latLng = coordinate.position.latitude + " / " + coordinate.position.longitude;
        var timeFormatted = new Monet.Format.MILLISECONDS(coordinate.diffTime).formatToElapsedTime().getValue();

        var template = new Monet.UI.LayoutGenerator((function (data) {
            return {
                "items": [
                    {
                        "items": [
                            {
                                "tag": "strong",
                                "items": [
                                    {
                                        "tag": "span",
                                        "html": Monet.I18n.getResourcesByKey("RouteDetail.equipmentOff.title"),
                                        "attributes": { "class": "i18nResource" }
                                    }
                                ]
                            },
                            {
                                "tag": "hr"
                            },
                            {
                                "items": [
                                    {
                                        "items": [
                                            {
                                                "tag": "span",
                                                "html": Monet.I18n.getResourcesByKey("RouteDetail.equipmentOff.currentDate"),
                                                "attributes": { "class": "i18nResource" }
                                            }
                                        ],
                                        "html": Monet.I18n.getResourcesByKey("RouteDetail.equipmentOff.currentDate") + ":",
                                        "attributes": { "class": "label" }
                                    },
                                    {
                                        "html": Monet.Format.DateTime.formatToLocale(data.coord.stoppedSince),
                                        "attributes": { "class": "content" }
                                    }
                                ],
                                "attributes": {
                                    "class": "routeDetailItemEquipmentOff"
                                }
                            },
                            {
                                "items": [
                                    {
                                        "items": [
                                            {
                                                "tag": "span",
                                                "html": Monet.I18n.getResourcesByKey("RouteDetail.EquipmentOff.dateDepart"),
                                                "attributes": {
                                                    "class": "i18nResource"
                                                }
                                            }
                                        ],
                                        "html": Monet.I18n.getResourcesByKey("RouteDetail.EquipmentOff.dateDepart") + ":",
                                        "attributes": {
                                            "class": "label"
                                        }
                                    },
                                    {
                                        "html": Monet.Format.DateTime.formatToLocale(data.depart),
                                        "attributes": {
                                            "class": "content"
                                        }
                                    }
                                ],
                                "attributes": {
                                    "class": "routeDetailItemEquipmentOff"
                                }
                            },
                            {
                                "items": [
                                    {
                                        "items": [
                                            {
                                                "tag": "span",
                                                "html": Monet.I18n.getResourcesByKey("RouteDetail.EquipmentOff.timeStopped"),
                                                "attributes": {
                                                    "class": "i18nResource"
                                                }
                                            }
                                        ],
                                        "html": Monet.I18n.getResourcesByKey("RouteDetail.EquipmentOff.timeStopped") + ":",
                                        "attributes": {
                                            "class": "label"
                                        }
                                    },
                                    {
                                        "html": data.elapsedTime,
                                        "attributes": {
                                            "class": "content"
                                        }
                                    }
                                ],
                                "attributes": {
                                    "class": "routeDetailItemEquipmentOff"
                                }
                            },
                            {
                                "items": [
                                    {
                                        "items": [
                                            {
                                                "tag": "span",
                                                "html": Monet.I18n.getResourcesByKey("RouteDetail.EquipmentOff.latLng"),
                                                "attributes": { "class": "i18nResource" }
                                            }
                                        ],
                                        "html": Monet.I18n.getResourcesByKey("RouteDetail.EquipmentOff.latLng") + ":",
                                        "attributes": { "class": "label" }
                                    },
                                    { "html": data.latLng, "attributes": { "class": "content" } }
                                ],
                                "attributes": { "class": "routeDetailItemEquipmentOff" }
                            }
                        ],
                        "attributes": { "class": "routeDetailEquipmentOff", "style": "width: 340px;" }
                    }
                ]
            };
        })({
            elapsedTime: timeFormatted,
            coord: coordinate,
            depart: coordinate.nextCoordinateDate,
            latLng: latLng
        }));

        return L.popup({
            offset: [0,26],
            minWidth: 345,
            maxWidth: 600
        }).setContent(template.render());
    };

    this.getPopup = function (marker) {

        if (this.customPopup) {
            return this.customPopup(marker);
        }

        return this.defaultPopup(marker);

    };

    this.getIcon = function () {

        var error = null;

        try {

            const markerClass = "equipOffInStop";

            L.EquipmentInOffIcon = L.Icon.extend({

                options: {
                    shadowUrl: null,
                    iconSize: [25, 24],
                    iconAnchor: [7.5, 12],
                    popupAnchor: [38, -22],
                    className: ''
                },

                createIcon: function () {

                    var div      = document.createElement('div'),
                        divChild = document.createElement('div'),
                        img      = this._createImg(require('static/images/map/markers/iconStopLayer.png'));

                    divChild.appendChild(img);
                    divChild.setAttribute("class", markerClass);

                    div.innerHTML = divChild.outerHTML;

                    this._setIconStyles(div, 'icon');

                    return div;
                },

                createShadow: function () {
                    return null;
                }
            });

            return new L.EquipmentInOffIcon();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on get icon marker");
            error.console();
        }
    };

    this.getMarkers = function (coord = []) {

        var markers = [];
        var getMarkersEquipmentInOff = function (context) {
            return function (item) {
                const verifyDate = function (inputDate) {
                    const trackEquipmentMapSelector = 'TrackEquipmentMaps';
                    const selector = (Monet.Utils.GetTabName() === trackEquipmentMapSelector) ? `#${trackEquipmentMapSelector}` : `#routeMaps_${routeId}`;
                    const eventDate = Monet.Format.DateTime.parse(inputDate).getTime();
                    let beginDate = document.querySelector(`${selector} input[name='routePlay_initialDate']`);
                    let endDate = document.querySelector(`${selector} input[name='routePlay_finalDate']`);
                    beginDate = (beginDate) ? Monet.Format.DateTime.parseLocale(beginDate.value).getTime() : '';
                    endDate = (endDate) ? Monet.Format.DateTime.parseLocale(endDate.value).getTime() : '';

                    return (eventDate >= beginDate && endDate >= eventDate);
                };

                if (verifyDate(item.get('date')) || verifyDate(item.get('nextCoordinateDate'))) {
                    var position = item.get('position');
                    var marker = new L.marker([
                        position.latitude,
                        position.longitude], {
                        icon: context.getIcon(),
                        zIndexOffset: 0
                    });

                    marker.kind = "equipOffInStop";
                    marker.coordinates = item.attributes;
                    marker.on('click', function () {
                        this.unbindPopup().bindPopup(context.getPopup(marker)).openPopup();
                    });

                    markers.push(marker);
                }
            };
        }(this);

        coord.forEach(getMarkersEquipmentInOff);

        return markers;

    };

    this.render = function (optionsToPopup) {

        Greenmile.Map.Utility.removeLayerByKind(map, ['equipOffInStop']);
        map._addLayers(this.getMarkers(_data, optionsToPopup));

    };

};
